import { useContext, createContext, useState, useCallback } from "react";
import { useModal } from "./useModal";
import { request } from "hooks/useOkoApi/useOkoApi";
import { getSessionState, clearSessionState } from "utils/sessionPersistence";

const shouldRehydrate = () => {
  const params = new URLSearchParams(window.location.search);
  // Don't rehydrate if redirected with an error — user needs to start fresh
  if (params.has("error") || params.has("auth_error")) return false;
  // Don't rehydrate if the URL has a different group code than what's stored —
  // the user is joining a new session and we must not send the stale code
  const urlCode = params.get("code");
  if (urlCode) {
    const stored = getSessionState();
    if (stored?.groupCode && stored.groupCode !== urlCode) return false;
  }
  return true;
};

export const useAppState = () => {
  const modal = useModal();
  const rehydrate = shouldRehydrate();
  const persisted = rehydrate ? getSessionState() : (() => { clearSessionState(); return null; })();
  console.log("[oko-patter] useAppState — rehydrate:", rehydrate, "persistedCode:", persisted?.groupCode, "urlCode:", new URLSearchParams(window.location.search).get("code"));
  const [displayName, setDisplayName] = useState(persisted?.displayName);
  const [groupCode, setGroupCode] = useState(persisted?.groupCode);
  const [sessionAuthType, setSessionAuthType] = useState(persisted?.sessionAuthType);
  const [isRecordSessions, setIsRecordSessions] = useState(persisted?.isRecordSessions);
  const [isSpectator, setIsSpectator] = useState();
  const [isVideoManuallyMuted, setIsVideoManuallyMuted] = useState();
  const [isSuperUser, setIsSuperUser] = useState(false);
  const [superUserChecked, setSuperUserChecked] = useState(false);

  const checkSuperUser = useCallback(() => {
    if (superUserChecked) return;
    setSuperUserChecked(true);
    request("account/is_super_user", { method: "GET" })
      .then((response) => setIsSuperUser(response))
      .catch(() => setIsSuperUser(false));
  }, [superUserChecked]);

  return {
    modal,
    displayName,
    setDisplayName,
    groupCode,
    setGroupCode,
    sessionAuthType,
    setSessionAuthType,
    isRecordSessions,
    setIsRecordSessions,
    isSpectator,
    setIsSpectator,
    isVideoManuallyMuted,
    setIsVideoManuallyMuted,
    isSuperUser,
    checkSuperUser,
  };
};

const Context = createContext();

export const AppStateProvider = ({ children }) => {
  const value = useAppState();
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useAppStateContext = () => {
  return useContext(Context);
};
